// extracted by mini-css-extract-plugin
export var bgImg = "Section-module--bgImg--074b9";
export var dark = "Section-module--dark--63eb7";
export var extraLarge = "Section-module--extraLarge--2e7ab";
export var extraSmall = "Section-module--extraSmall--b8b1e";
export var large = "Section-module--large--a5a46";
export var light = "Section-module--light--b98d3";
export var medium = "Section-module--medium--c972f";
export var micro = "Section-module--micro--133b5";
export var none = "Section-module--none--2db27";
export var removeBottom = "Section-module--removeBottom--532aa";
export var removeTop = "Section-module--removeTop--9eb53";
export var section = "Section-module--section--e6268";
export var sectionBackgroundImageContainer = "Section-module--sectionBackgroundImageContainer--f36c9";
export var sectionContainer = "Section-module--sectionContainer--a55e2";
export var sectionContent = "Section-module--sectionContent--02215";
export var sectionTitle = "Section-module--sectionTitle--91437";
export var small = "Section-module--small--c3182";
export var transparent = "Section-module--transparent--fc4e6";